import { media } from "src/layouts/utils";
import styled from "styled-components";

export const InnerContainer = styled.div`
  max-width: 1444px;
  width: 100%;

  ${media.phone`
        max-width: 100%;
        overflow-x: ${(props) => (props.noOverflow ? "unset" : "hidden")};
        overflow-y: ${(props) => (props.noOverflow ? "unset" : "hidden")};
		padding-inline: 0;
    margin: 1.5rem 0;
    `}

  margin: 3.5rem 0 2rem;
`;

export const ContainerListButton = styled.div`
  display: grid;
  grid-auto-flow: column;
  width: 100%;
  justify-content: space-evenly;
  padding-left: 130px;
  padding-right: 130px;
  grid-gap: 1rem;

  @media (max-width: 1050px) {
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 48px;
    display: flex;
    flex-direction: column;
  }

  ${media.phone`
    padding-bottom: 0;
  `}
`;

export const Image = styled.img`
	max-height: 3rem;
	// transform: ${({ flip }) => (flip ? "scaleX(-1) rotate(200deg)" : "unset")};
	${media.desktop`
      display: none;
    `}
`;
export const ContentImage = styled.div`
  height: 75%;
  display: flex;
  align-items: center;
  ${media.desktop`
      display: none;
    `}
`;
